import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.less";

import IconSvg from "./plugins/icons";
Vue.use(ElementUI);
Vue.use(IconSvg);
Vue.use(Antd);
Vue.config.productionTip = false;
import jikerResponsive from "jiker-responsive";
import isPC from "jiker-responsive/build/isPC";

Vue.use(jikerResponsive);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
// import isPC from "./utils/isPC";

(function resize(doc, win) {
  if (!isPC()) {
    const docEl = doc.documentElement;
    const resizeEvt =
      "orientationchange" in window ? "orientationchange" : "resize";
    const recalc = function recalc() {
      const { clientWidth } = docEl;
      if (!clientWidth) return;
      if (clientWidth >= 640) {
        docEl.style.fontSize = "100px";
      } else {
        docEl.style.fontSize = `${100 * (clientWidth / 375)}px`;
        //要计算的根字体大小值 = 基准值 * (实际屏幕宽度 / 设计图尺寸 )
      }
    };
    if (!doc.addEventListener) return;
    win.addEventListener(resizeEvt, recalc, false);
    doc.addEventListener("DOMContentLoaded", recalc, false);
  }
})(document, window);
